import React, { useContext, useEffect, useState, ChangeEvent, FormEvent } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import PageBuilder from '../../../library/Builders/PageBuilder/PageBuilder';
import { isFormValid } from '../../../library/Core/SmartFunctions';
import Swal from 'sweetalert2';
import IntrestedJobFormLayout from './IntrestedJobFormLayout';
import JobListingService from './JobListingService';

const IntrestedJobModal = () => {
    const { state, dispatch } = useContext(SmartContext);

    const handleSubmit = async (
        event: React.SyntheticEvent<HTMLButtonElement>,
        state: State,
        dispatch: (dispatchEvent: DispatchEvent) => void
    ) => {
        event.preventDefault();

        if (!isFormValid(state, dispatch)) {
            dispatch({ type: 'SHOW_ERRORS' });
            return;
        }
        const params = {
            jobId: state?.modalData?.data?.id,
            isSaved: state?.modalData?.data?.isSaved ??  0,
            isViewed:  state?.modalData?.data?.isViewed ??  1,
            ...state?.data?.jobPostingIntrestedJob
        };

         const response = await JobListingService.savePreference(params);
            console.log("API response:", response, "Status:", response?.status);
            // If we get any response, try to update UI
            if (response) {
                const jobs = state?.data?.filteredData;                
                if (jobs && jobs.length > 0) {
                    // Create a completely new array to force React to detect the change
                    const modifiedJobs = jobs.map((job: any) => {
                        if (job.id == params.jobId) {
                            console.log("Updating job:", job.id, "Old isInterested:", job.isInterested, "New isInterested:", params.isInterested);
                            // Create a new object for the modified job
                            return {
                                ...job,
                                isInterested: params.isInterested,
                                isSaved: params.isSaved,
                                isViewed: params?.isViewed,
                                totalInterestedCnt: (job.totalInterestedCnt || 0) + 1,
                            };
                        }
                        return job;
                    });

                    console.log("Modified jobs after update:", modifiedJobs);
                    let sentInterest = (state.data.summaryCounts?.sentInterest || 0);
                    let activeList = (state.data.summaryCounts?.activeList || 0);
                    const intrestArray=['IMMEDIATELY','EXPLORING','INTERESTED']
                    if (params?.isInterested && intrestArray.includes(params.isInterested)) {
                        sentInterest += 1;
                        activeList  -= 1;
                    }
                    // Update the entire data object to ensure state change is detected
                    dispatch({
                        type: 'REFRESH_DATA',
                        payload: {
                            data: {
                                ...state.data,
                                filteredData: modifiedJobs,
                                summaryCounts: {
                                    ...state.data.summaryCounts,
                                    sentInterest: sentInterest,
                                    activeList :activeList
                                }
                            }
                        }
                    });

                    dispatch({type: 'TOGGLE_MODAL_VISIBILITY',payload: { modalName: 'showJobPostingIntrested' }});
                    Swal.fire({
                        title: "Done!",
                        text: "Job Intrest Submitted Successfully",
                        icon: "success"
                    });
                }
            }
     }

    useEffect(() => {
        dispatch({ type: 'ADD_ACTIONS', payload: { ...state.actions, SUBMIT_INTREST: handleSubmit } });
    }, []);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <IntrestedJobFormLayout>{!state.flags.isDataLoading && <PageBuilder />}</IntrestedJobFormLayout>
        </SmartContext.Provider>
    );
};

export default IntrestedJobModal;
